<template>
  <div>
    <template v-for="chart in charts">
      <Chart
        :type="chart.type"
        @delete="$emit('delete', chart.id)"
        @show-form="$emit('show-form', chart.id)"
        :key="chart.id"
        :chart="chart"
        :delete-chart="() => 1"
        class="mb-2"
      />
    </template>
  </div>
</template>
<script>
import Chart from "./Chart.vue";

export default {
  props: {
    charts: {
      type: Array,
      require: true
    }
  },
  components: { Chart }
};
</script>
